var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',_vm._b({staticClass:"cursor-pointer",attrs:{"name":"fa fa-info-circle","color":"white"}},'q-icon',_vm.$attrs,false),[_c('tooltip',[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }